import React from 'react';

const MODULES = [
  { key: 'mca',        label: 'MCA',                     url: '/workspace/mca',        gate: null,
    desc: 'Company Secretarial & MCA/ROC compliance filings',
    icon: 'M3 6h18M3 12h18M3 18h18' },
  { key: 'hr',          label: 'HR',                       url: '/workspace/hr',         gate: 'hr',
    desc: 'Employee records, attendance & payroll',
    icon: 'M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zM22 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75' },
  { key: 'referrals',   label: 'Referrals',                url: '/workspace/referrals',  gate: 'referrals',
    desc: 'Manage referral partners & commissions',
    icon: 'M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75' },
  { key: 'people',      label: 'People',                   url: '/workspace/people',     gate: 'people',
    desc: 'Team directory, HR profiles & user records',
    icon: 'M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 3a4 4 0 110 8 4 4 0 010-8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75' },
  { key: 'renewals',    label: 'Renewals',                 url: '/workspace/renewals',   gate: 'renewals',
    desc: 'Track and manage license & registration renewals',
    icon: 'M23 4v6h-6 M20.49 15a9 9 0 11-2.12-9.36L23 10' },
  { key: 'dpr',         label: 'DPR / Project Report',     url: '/workspace/dpr',        gate: null,
    desc: 'Project reports & CMA data for bank loans and subsidy',
    icon: 'M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z M14 2v6h6 M16 13H8 M16 17H8' },
  { key: 'income-tax',  label: 'Income Tax',               url: '/workspace/income-tax', gate: null,
    desc: 'Tax compliance, return filing, tracking & notices',
    icon: 'M6 3h12M6 8h12M12 8l-6 13M6 3c0 7 6 10 6 10s6-3 6-10' },
  { key: 'gst',         label: 'GST',                      url: '/workspace/gst',        gate: null,
    desc: 'GST return filing & compliance',
    icon: 'M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15' },
];

function TileIcon({ d }) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      {d.split(' M').map((seg, i) => <path key={i} d={i === 0 ? seg : 'M' + seg} />)}
    </svg>
  );
}

// Workspace hub — rendered inline in Dashboard (same tab, like Settings).
// Each tile opens its module full-screen in a NEW browser tab.
export default function Workspace({ darkMode = false, T, can }) {
  const theme = T || { bg2: '#fff', bg3: '#f8faff', border: '#e8edf5', border2: '#e2e8f0', text: '#0f1f45', text2: '#4a5568', text3: '#94a3b8', cardBorder: '#f1f5f9' };

  const visible = MODULES.filter(m => !m.gate || !can || can(m.gate, 'view'));

  return (
    <div style={{ padding: 32, minHeight: '100vh', background: darkMode ? 'radial-gradient(ellipse at 80% 0%,rgba(249,115,22,0.07) 0%,transparent 60%),#0a0f1e' : 'radial-gradient(ellipse at 80% 0%,rgba(249,115,22,0.05) 0%,transparent 50%),#f4f7ff' }}>
      <div style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 18, fontWeight: 700, color: theme.text, margin: 0 }}>Workspace</h2>
        <p style={{ fontSize: 13, color: theme.text3, margin: '4px 0 0' }}>
          Dedicated modules for your firm, based on your subscription plan. Each opens in its own tab.
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 14 }}>
        {visible.map(m => (
          <button
            key={m.key}
            onClick={() => window.open(m.url, '_blank')}
            style={{
              textAlign: 'left', background: theme.bg2, border: `1px solid ${theme.cardBorder}`, borderRadius: 16,
              padding: 20, cursor: 'pointer', transition: 'all 0.15s',
              boxShadow: darkMode ? '0 2px 12px rgba(0,0,0,0.2)' : '0 2px 8px rgba(15,31,69,0.04)',
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = '#3b82f6'; e.currentTarget.style.boxShadow = darkMode ? '0 4px 20px rgba(59,130,246,0.15)' : '0 4px 16px rgba(59,130,246,0.1)'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = theme.cardBorder; e.currentTarget.style.boxShadow = darkMode ? '0 2px 12px rgba(0,0,0,0.2)' : '0 2px 8px rgba(15,31,69,0.04)'; }}
          >
            <div style={{ width: 42, height: 42, borderRadius: 12, background: darkMode ? 'rgba(255,255,255,0.06)' : theme.bg3, border: `1px solid ${theme.border}`, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 14, color: '#e8620a' }}>
              <TileIcon d={m.icon} />
            </div>
            <p style={{ fontSize: 13, fontWeight: 600, color: theme.text, margin: '0 0 6px' }}>{m.label}</p>
            <p style={{ fontSize: 11, color: theme.text3, lineHeight: 1.5, margin: 0, overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
              {m.desc}
            </p>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 6, marginTop: 12 }}>
              <span style={{ fontSize: 10, color: theme.text3 }}>Opens in new tab</span>
              <div style={{ width: 24, height: 24, borderRadius: '50%', background: darkMode ? 'rgba(255,255,255,0.06)' : theme.bg3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={theme.text3} strokeWidth="2"><path d="M7 17L17 7M7 7h10v10"/></svg>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
